<template>

    <div class="container">
        
        <app-head title="Zones" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Zones') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.zones.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="zones.meta" />
        </div>

        <div class="card">
            <data-table :items="zones.data"
                        :links="zones.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="zone in zones.data" :key="zone.id">
                    <td>
                        {{ zone.id }}
                    </td>
                    <td>
                        {{ zone.uid }}
                    </td>
                    <td>
                        <inertia-link class=" stretched-link" :href="route('admin.zones.edit', zone)">
                            {{ zone.name }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ zone.description || '-' | truncateWords }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    
    import Results from '@/shared/Admin/Results';

    export default {
        props: {
            filters: Object,
            zones: Object,
        },
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    uid: {label: 'UID', sortable: 'uid'},
                    name: {label: 'Name', sortable: 'name'},
                    description: {label: 'Description'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.zones.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>